import { lambdaHostname } from 'shared/constants';

export const appendThumbnailLink = (thumbnail: string) => {
  if (!thumbnail) return '';
  return /^https?:/.test(thumbnail) ? thumbnail ?? '' : `${lambdaHostname}${thumbnail}`;
};
